import { AUTH_INVALID_EVENT } from '@/features/auth/context/AuthContext';
export function planToken(){try{return JSON.parse(localStorage.getItem('claro-auth-session')||'{}').reviewToken||'';}catch{return '';}}
export async function planRequest<T>(path:string,options?:RequestInit):Promise<T>{
  const response=await fetch(`/claro/api/plan-v1${path}`,{...options,headers:{'Content-Type':'application/json',Authorization:`Bearer ${planToken()}`,...options?.headers}});
  const data=await response.json().catch(()=>({}));
  if(response.status===401)window.dispatchEvent(new Event(AUTH_INVALID_EVENT));
  if(!response.ok)throw new Error(data.message||'Não foi possível concluir a operação.');
  return data;
}
export async function downloadPlanArtifact(caseId:string,artifactId:string,name:string){
  const response=await fetch(`/claro/api/plan-v1/cases/${caseId}/artifacts/${artifactId}`,{headers:{Authorization:`Bearer ${planToken()}`}});
  if(!response.ok)throw new Error('Não foi possível baixar o arquivo.');
  const url=URL.createObjectURL(await response.blob()),anchor=document.createElement('a');anchor.href=url;anchor.download=name;anchor.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
